<template>
    <nav v-if="!hide" id="sidebar" :class="`${!siderCollapsed ? 'col-md-3 col-lg-2 d-sm-none d-none d-lg-block sidebar mt-1' : 'col-md-3 col-lg-1 d-sm-none d-none d-lg-block sidebar mt-1 not-active'}`">
         <div class="sidebar-sticky">
            <ul class="nav flex-column">
                <li class="nav-item mt-1">
                    <el-tooltip :disabled="!siderCollapsed" content="Home" placement="right">
                        <router-link to="/home" class="nav-link">
                             <i class="icon fas fa-home"></i> <span>Home</span> 
                        </router-link>
                    </el-tooltip>
                </li>
                <li v-for="m in filteredMenu" :key="m.rule" class="nav-item">
                    <template v-if="showMenuAcesso(m.rule, m)">
                        <el-tooltip :disabled="!siderCollapsed" :content="m.name" placement="right">
                            <router-link :to="m.url" class="nav-link">
                                <i :class="`icon ${m.icon}`"></i> <span>{{ m.name }}</span> 
                                <template v-if="m.onlyPremium || m.rule === 'usuarios'">
                                    <span class="premium-tab-menu">
                                        <i class="far fa-star"></i>
                                    </span>
                                </template>
                            </router-link>
                        </el-tooltip>
                    </template>
                    <template v-else>
                        <el-tooltip content="Não possui acesso" placement="right">
                            <span class="nav-link" style="cursor: no-drop; opacity: 0.6;">
                                <i :class="`icon ${m.icon}`"></i> <span>{{ m.name }}</span> 
                                <template v-if="m.onlyPremium">
                                    <span class="premium-tab-menu">
                                        <i class="far fa-star"></i>
                                    </span>
                                </template>
                            </span>
                        </el-tooltip>
                    </template>
                </li>
            </ul>
            <div v-if="!siderCollapsed && !premiumUser()" @click="showModalPremium('show')" class="seja-premium-btn">
                <i class="far fa-star"></i>
                <b>Seja Premium</b>
                <span>Clique para saber mais</span>
            </div>
            <div class="sidebar-logout d-sm-block d-block d-lg-none">
                <span @click="logout" class="fas fa-power-off">
                    &nbsp;<b style="font-size:0.8em; font-family: 'Sarabun', sans-serif, Helvetica, Arial !important;">Sair</b>
                </span>
            </div>
        </div>
        
    </nav>
</template>

<script>
import router from '@/router.js'
import { mapState } from 'vuex';
import menu from '@/helpers/menu'
import isHavaianas from '@/mixins/isHavaianas';
import hideElements from '@/mixins/hideElements';


export default {
    name: 'sidebar',
    computed: {
        arrowMovePx() { // add valores para o translate do arrow - menu
            return this.linkHeight() * this.activeLinkIndex
        },
        filteredMenu() {
            return this.menu;
        },
        ...mapState(['siderCollapsed','acessos'])
    },
    data(){
        return {
            linkHeight: () => { // height do router link
                return this.siderCollapsed ? 47 : 37
            },
            activeLinkIndex: 0,
            menu: menu
        }
    },
    mixins: [isHavaianas, hideElements],
    methods: {
      findActiveLink() { // Pego o index do router link ativo
          let navLinks = document.querySelectorAll('#sidebar .nav-link')
          navLinks.forEach((link, index) => {
              if (link.classList.contains("router-link-active")) {
                  this.activeLinkIndex = index
              }
          });
      },
      async logout(){
        const user = localStorage.getItem("user"); 
        const parse = JSON.parse(user);
        const {email} = parse.user;
              await this.axios.post(this.$urls.DELETE_TOKEN,{email:email});
              this.trackingF360(this, 'Logout', 'Dimensões personalizadas');

        localStorage.removeItem('accessToken')
        localStorage.removeItem('user')
        localStorage.removeItem('loginToken')

        router.push({ path: '/', name: 'public' })
      },
      showMenuAcesso(nameMenu, config) {
        // Define a regra inicial como `false`
        let regra = false;

        // Verifica as condições para permitir o acesso
        if (
            (this.acessos.length && this.acessos.find(r => r.name.toLowerCase() === nameMenu.toLowerCase())) || 
            (!this.acessos.length || this.acessos.find(r => r.name === 'sysAdmin'))
        ) {
            regra = true;
        }

        // Verifica a configuração para usuários premium
        if (config.onlyPremium === true && !this.premiumUser()) {
            regra = false;
        }

        return regra;
      }

    },
    mounted(){
        this.$watch("$route", this.findActiveLink, {
            immediate: true
        });
    },
}
</script>

<style lang="scss" scoped>
    .sidebar-sticky {
        position: relative;
        top: 0;
        height: calc(100vh - 48px);
        padding-top: .5rem;
        overflow-x: hidden;
        overflow-y: auto;
    }

    @supports ((position: -webkit-sticky) or (position: sticky)) {
        .sidebar-sticky {
            position: -webkit-sticky;
            position: sticky;
        }
    }

    .sidebar {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
        padding: 48px 0 0;
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
        background-color: #769ec3;
        transition:0.3s;
        .nav-link{
            font-weight: 500;
            margin: 0;
            transition:0.2s;
            color: #e6e6e6;
            padding-left: 40px;
            border-radius: 4px;
            margin-top: 4px;
            &:hover, &:active{
                color: #fff;
            }
            &.router-link-exact-active {
                background: #577c9e;
                color: #fff;
            }
        }
        .nav-cadastro{
            padding-top: 10px;
            padding-left: 10px;
            margin: 0;
            color: #295073;
        }
        span{
            margin-left:15px;
            font-size:0.9em;
            text-align:left;
            transition:0.3s;
            @media (max-width: 1080px) {
                font-size:1em;
                margin-left: 2px;
            }
        }
        .icon{
            float: left;
            margin-top: 4px;
            position: relative;
            font-size: 18px;
            width: 22px;
            text-align: center;
            @media (max-width: 1080px) {
                font-size:19px;
                right: 6px;
            }
        }
        &.not-active {
            
            .nav-link {
                padding-left: 37px;
                @media (max-width: 1500px) {
                    padding-left: 26px;
                }
                @media (max-width: 1400px) {
                    padding-left: 21px;
                }
                @media (max-width: 1100px) {
                    padding-left: 14px;
                }

            }
            span{
                font-size:0;
            }
            .icon {
                font-size: 20px;
                float:none;
                margin-left: 13px;
            }
            .nav-cadastro{
                padding-left: 0;
            }
        }
        span.premium-tab-menu {
            font-size: 8px !important;
            color: #525252;
            font-weight: bold;
            background: #e9d205;
            padding: 1px 5px 2px 4px;
            border-radius: 9px;
            position: absolute;
            right: 19px;
        }
    }
    .sidebar-heading {
        font-size: .75rem;
        text-transform: uppercase;
    }
    .sidebar-logout {
        width: 100%;
        position: absolute;
        text-align: center;
        bottom: 10px;
        font-size: 20px;
        color: #fff;
    }
    .sidebar-logout span{
        cursor:pointer;
        margin-left: 0 !important;
        font-size: 1em !important;
        &:hover{
            color:#486d8e;
        }
    }
    #sidebar .nav-item{
        padding: 0 8px;
    }
    #sidebar .nav-item a:hover{
        background: #8eadc9;
        transition: .5s;
    }

    .seja-premium-btn {
        display: block;
        position: relative;
        border: 3px solid #e9d205;
        background: #e3f5bb;
        border-radius: 15px;
        padding: 5px;
        margin: 8px 15px 0;
        font-size: 0.8em;
        color: #6f6d58;
        cursor:pointer;
        transition:0.1s;
        i.fa-star {
            float: left;
            margin: 10px 6px;
            color: #cdb90b;
            transition:0.2s;
            @media (min-width: 1400px) {
                margin: 12px 6px;
            }
        }
        b, span {
            display:block;
        }
        span {
            margin-top: -5px
        }

        @media (min-width: 1400px) {
            padding: 10px 15px;
            font-size: 1em;
        }
        &:hover {
            background:#fff;
            b, span {
                color: #cdb90b;
            }
            i.fa-star {
                font-weight:bold;
            }
        }
    }
    
</style>
